<template>
  <div class="contain">
    <div class="title">基础用法</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow1')"
        ><span :class="basicActive ? '' : 'text'">{{
          basicText
        }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow1"
        @oncancel="oncancel('isShow1')"
        @getAdd="getAdd1"
      ></mx-address-picker>
    </div>

    <div class="title">自定义弹窗高度</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow2')"
        ><span :class="PHActive ? '' : 'text'">{{ PHText }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow2"
        :popupHeight="popupHeight"
        @oncancel="oncancel('isShow2')"
        @getAdd="getAdd2"
      ></mx-address-picker>
    </div>

    <div class="title">自定义弹窗关闭按钮</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow3')"
        ><span :class="NCBActive ? '' : 'text'">{{ NCBText }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow3"
        :isShowCloseBtn="isShowCloseBtn"
        @oncancel="oncancel('isShow3')"
        @getAdd="getAdd3"
      ></mx-address-picker>
    </div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow4')"
        ><span :class="CBActive ? '' : 'text'">{{ CBText }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow4"
        :imgSrc="imgSrc"
        :imgSrcStyle="imgSrcStyle"
        @oncancel="oncancel('isShow4')"
        @getAdd="getAdd4"
      ></mx-address-picker>
    </div>

    <div class="title">自定义隐藏省份</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow5')"
        ><span :class="HPActive ? '' : 'text'">{{ HPText }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow5"
        :noShowPro="noShowPro"
        @oncancel="oncancel('isShow5')"
        @getAdd="getAdd5"
      ></mx-address-picker>
    </div>

    <div class="title">自定义顶部标题文案及文案样式</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow6')"
        ><span :class="TTActive ? '' : 'text'">{{ TTText }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow6"
        :popupHeaderText="popupHeaderText"
        @oncancel="oncancel('isShow6')"
        @getAdd="getAdd6"
      ></mx-address-picker>
    </div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow7')"
        ><span :class="TTSActive ? '' : 'text'">{{ TTSText }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow7"
        :popupHeaderTextStyle="popupHeaderTextStyle"
        @oncancel="oncancel('isShow7')"
        @getAdd="getAdd7"
      ></mx-address-picker>
    </div>

    <div class="title">自定义tab栏样式及子栏样式</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow8')"
        ><span :class="tabsActive ? '' : 'text'">{{
          tabsText
        }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow8"
        :popupTabStyle="popupTabStyle"
        @oncancel="oncancel('isShow8')"
        @getAdd="getAdd8"
      ></mx-address-picker>
    </div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow9')"
        ><span :class="tabActive ? '' : 'text'">{{ tabText }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow9"
        :popupTabListStyle="popupTabListStyle"
        :tabTextActive="tabTextActive"
        @oncancel="oncancel('isShow9')"
        @getAdd="getAdd9"
      ></mx-address-picker>
    </div>

    <div class="title">自定义tab栏文案</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow11')"
        ><span :class="tabsDataActive ? '' : 'text'">{{
          tabsDataText
        }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow11"
        :alternateAdd="alternateAdd"
        @oncancel="oncancel('isShow11')"
        @getAdd="getAdd11"
      ></mx-address-picker>
    </div>

    <div class="title">自定义滑线样式</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow10')"
        ><span :class="lineActive ? '' : 'text'">{{
          lineText
        }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow10"
        :lineStyle="lineStyle"
        @oncancel="oncancel('isShow10')"
        @getAdd="getAdd10"
      ></mx-address-picker>
    </div>

    <div class="title">自定义tab栏省市区街道外盒子样式</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow12')"
        ><span :class="wrapperActive ? '' : 'text'">{{
          wrapperText
        }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow12"
        :wrapperStyle="wrapperStyle"
        @oncancel="oncancel('isShow12')"
        @getAdd="getAdd12"
      ></mx-address-picker>
    </div>

    <div class="title">自自定义列表单个选项盒子样式</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow13')"
        ><span :class="optionActive ? '' : 'text'">{{
          optionText
        }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow13"
        :optionStyle="optionStyle"
        @oncancel="oncancel('isShow13')"
        @getAdd="getAdd13"
      ></mx-address-picker>
    </div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow14')"
        ><span :class="otActive ? '' : 'text'">{{ otText }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow14"
        :optionTextStyle="optionTextStyle"
        @oncancel="oncancel('isShow14')"
        @getAdd="getAdd14"
      ></mx-address-picker>
    </div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow15')"
        ><span :class="otsActive ? '' : 'text'">{{ otsText }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow15"
        :optionTextActive="optionTextActive"
        @oncancel="oncancel('isShow15')"
        @getAdd="getAdd15"
      ></mx-address-picker>
    </div>

    <div class="title">自定义选中选项右侧图标展示状态及样式</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow16')"
        ><span :class="rIconActive ? '' : 'text'">{{
          rIconText
        }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow16"
        :showIcon="showIcon"
        @oncancel="oncancel('isShow16')"
        @getAdd="getAdd16"
      ></mx-address-picker>
    </div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="btnClick('isShow17')"
        ><span :class="rIconsActive ? '' : 'text'">{{
          rIconsText
        }}</span></van-button
      >
      <mx-address-picker
        :isShow="isShow17"
        :rightIcon="rightIcon"
        @oncancel="oncancel('isShow17')"
        @getAdd="getAdd17"
      ></mx-address-picker>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AddressPickerDemo',
  data() {
    return {
      basicText: '请选择所在地区',
      PHText: '请选择所在地区',
      NCBText: '隐藏关闭按钮',
      CBText: '自定义关闭按钮',
      HPText: '请选择所在地区',
      TTText: '自定义标题文案',
      TTSText: '自定义标题文案样式',
      tabsText: '自定义tab栏样式',
      tabText: '自定义tab栏子项样式',
      lineText: '请选择所在地区',
      tabsDataText: '请选择所在地区',
      wrapperText: '请选择所在地区',
      optionText: '自定义选项盒子样式',
      otText: '自定义选项文案样式',
      otsText: '自定义选中选项后，字体更换的颜色',
      rIconText: '隐藏右侧图标',
      rIconsText: '自定义右侧图标样式',
      rIconsActive: false,
      rIconActive: false,
      otsActive: false,
      otActive: false,
      optionActive: false,
      wrapperActive: false,
      tabsDataActive: false,
      lineActive: false,
      tabActive: false,
      tabsActive: false,
      HPActive: false,
      basicActive: false,
      PHActive: false,
      NCBActive: false,
      CBActive: false,
      TTActive: false,
      TTSActive: false,
      showRound: true, // van-button 圆角
      isShow1: false, // 是否显示级联弹窗
      isShow2: false, // 是否显示级联弹窗
      isShow3: false,
      isShow4: false,
      isShow5: false,
      isShow6: false,
      isShow7: false,
      isShow8: false,
      isShow9: false,
      isShow10: false,
      isShow11: false,
      isShow12: false,
      isShow13: false,
      isShow14: false,
      isShow15: false,
      isShow16: false,
      isShow17: false,
      isShowCloseBtn: false,
      imgSrc: require('../assets/image/ap_close.png'), // 关闭按钮默认本地图片
      imgSrcStyle: {
        width: '30px',
        height: '30px',
        marginTop: '5px',
        marginRight: '15px',
      }, // 关闭按钮样式 m-popup-header-close
      noShowPro: ['西藏自治区', '广西壮族自治区'], // 需要隐藏的省份
      popupHeight: '70%', // 弹窗相对屏幕高度
      popupHeaderStyle: {}, // 顶部盒子样式
      popupHeaderText: '请用户选择地区', // 顶部标题文案
      popupHeaderTextStyle: {
        fontSize: '14px',
        color: '#660099',
      }, // 顶部标题文案样式, 对应css属性 m-popup-header-text
      popupTabStyle: {
        paddingLeft: '8px',
        fontSize: '14px',
      }, // tab栏样式, 对应css属性 m-popup-tab
      popupTabListStyle: {
        color: '#0099ff',
        padding: '0 12px',
      }, // tab栏子项样式, 对应css属性 m-popup-tab-list
      tabTextActive: '#0000ff', // 选中地址后，tab栏子项字体颜色
      lineStyle: {
        width: '30px',
        backgroundColor: '#cc0000',
      }, // tab栏下划线样式, 对应css属性 m-popup-line
      wrapperStyle: {
        backgroundImage:
          'url(' + require('../assets/image/board_one.png') + ')',
        backgroundSize: '100%',
      }, // tab栏下多个列表的外盒子样式，对应属性 m-popup-content-wrapper
      contentStyle: {}, // tab栏下多个列表的内盒子样式
      optionStyle: {
        padding: '0 24px',
        paddingTop: '8px',
      }, // 每个选项盒子样式, 对应css属性 m-popup-content-options-item
      optionTextStyle: {
        color: '#9999CC',
      }, // 每个选项文案样式
      showIcon: false, // 选中选项时，是否展示选项最右侧图标
      rightIcon: {
        src: require('../assets/image/selected.png'),
        width: '20px',
        height: '20px',
      }, // 最右侧图标样式，仅支持图片地址、宽度和高度
      optionTextActive: '#FF0000', // 选中选项后，选项的字体颜色
      alternateAdd: ['选择省份', '选择城市', '选择区县', '选择街道'],
    }
  },
  methods: {
    btnClick(isShow) {
      this[isShow] = true
    },
    oncancel(isShow) {
      this[isShow] = false
    },
    getAdd1(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'basicText', 'basicActive')
    },
    getAdd2(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'PHText', 'PHActive')
    },
    getAdd3(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'NCBText', 'NCBActive')
    },
    getAdd4(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'CBText', 'CBActive')
    },
    getAdd5(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'HPText', 'HPActive')
    },
    getAdd6(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'TTText', 'TTActive')
    },
    getAdd7(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'TTSText', 'TTSActive')
    },
    getAdd8(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'tabsText', 'tabsActive')
    },
    getAdd9(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'tabText', 'tabActive')
    },
    getAdd10(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'lineText', 'lineActive')
    },
    getAdd11(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'tabsDataText', 'tabsDataActive')
    },
    getAdd12(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'wrapperText', 'wrapperActive')
    },
    getAdd13(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'optionText', 'optionActive')
    },
    getAdd14(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'otText', 'otActive')
    },
    getAdd15(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'otsText', 'otsActive')
    },
    getAdd16(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'rIconText', 'rIconActive')
    },
    getAdd17(data) {
      console.warn('获得用户已选择的完整地址: ', data)
      this.handleAdd(data, 'rIconsText', 'rIconsActive')
    },
    handleAdd(data, text, cssActive) {
      this[text] = data.join('')
      this[cssActive] = true
    },
  },
  created() {
    let ua = navigator.userAgent.toLowerCase()
    if (/meiju|msmart/.test(ua)) {
      // meiju 环境下
      this.$bridge.getAllBarHeight().then((res) => {
        console.warn('getAllBarHeight原生接口返回:->', res)
        if (res.bottomArc > 0) {
          this.$bridge
            .setBottomStatusBar({
              isDisplay: 1, // ios安全区别是否显示
            })
            .catch((err) => {
              console.warn('setBottomStatusBar原生接口返回:->', err)
            })
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.contain {
  width: 375px;
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 30px;
  .title {
    padding-top: 30px;
    margin-left: 20px;
    font-size: 14px;
    color: rgba(69, 90, 100, 0.6);
  }
  .btn {
    width: 50px;
    height: 30px;
    background-color: cornflowerblue;
  }
  .top {
    margin-top: 15px;
  }
  .wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .text {
      color: rgb(200, 201, 204);
    }
  }
}
.van-button--info {
  width: 90%;
  /* height: 44px; */
  color: #000000;
  background-color: #ffffff;
  border: none;
  border-radius: 45px;
}
</style>
